<template>
	<el-dialog title="" :visible.sync="showVisible" width="578px" center :close-on-click-modal="false">
		<Table
			:table-data="tableData"
			:table-head="tableHead"
			:is-show-selection="false"
			:isShowPage="false"
			:showOperation="false"
			:tableHeight="tableHeight"
		>
		</Table>
	</el-dialog>
</template>

<script>
export default {
	components: {
		Table: () => import('@/components/Table/table'),
	},
	data() {
		return {
			showVisible: false,
			tableHead: [
				{
					label: '分钟数',
					prop: 'usageTime',
					formatter: (row) => {
						return row.usageTime ? row.usageTime / 60 : '-';
					},
				},
				{
					label: '价格（人民币）',
					prop: 'price',
					formatter: (row) => {
						return row.price ? row.price / 100 + '元' : '-';
					},
				},
			],
			tableData: [],
		};
	},
	computed: {
		tableHeight() {
			return window.innerHeight - 300;
		},
	},
};
</script>

<style lang="scss" scoped>
/deep/ .el-table {
	margin-bottom: 20px;
}
</style>

